<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? "Edit Programme" : "Add Programme" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              maxlength="3"
              hide-details="auto"
              :readonly="edit"
              :rules="[rules.required, rules.number, rules.code]"
              @input="form.code = form.code.toUpperCase()"
          /></v-col>
          
          <v-col cols="6" v-if="viewPartner"
            ><v-autocomplete
              v-if="viewPartner"
              v-model="form.partner_id"
              :items="partners"
              item-text="name"
              item-value="id"
              label="Partner*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
              readonly
              append-icon=""
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.degree_id"
              :items="degrees"
              item-text="short_name"
              item-value="id"
              label="Degree*"
              :readonly="prefilled_degree"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.specialization"
              label="Specialization"
              outlined
              dense
              hide-details="auto"
            />
          </v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.department_id"
              :items="departments"
              item-text="name"
              item-value="id"
              label="Department*"
              :readonly="prefilled_department"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.duration_type"
              :items="durations"
              item-text="name"
              item-value="id"
              label="Format*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model="form.duration"
              label="Duration*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.number]"
          /></v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.qualifications"
              :items="qualifications"
              item-text="name"
              item-value="id"
              label="Qualifications*"
              outlined
              chips
              small-chips
              dense
              multiple
              hide-details="auto"
              :rules="[rules.required, rules.arrayMinOne]"
            />
          </v-col>
          <v-col cols="6">
            <div class="d-flex justify-start">
              <v-checkbox
                v-model="form.ugc_data_upload"
                hide-details="auto"
                class="mt-0"
              ></v-checkbox>
              <label class="mt-1 form-label"> UGC Data Upload</label>
            </div>
          </v-col>
          <v-col cols="6" v-if="form.ugc_data_upload"
            ><v-text-field
              v-model.trim="form.ugc_code"
              label="UGC Code*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
              @input="form.ugc_code = form.ugc_code.toUpperCase()"
          /></v-col>  
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";
import { durations } from "@/constants/enum";

export default {
  props: {
    program: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    department_id: {
      type: Number,
      default: () => null,
    },
    degree_id: {
      type: Number,
      default: () => null,
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    partners: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        department_id: null,
        degree_id: null,
      },
      degrees: [],
      departments: [],
      qualifications: [],
      exisiting_qualifications: [],
      prefilled_department: false,
      prefilled_degree: false,
      durations: durations,
    };
  },
  computed: {},
  async created() {
    await this.getDepartments();
    await this.getDegrees();
    if (this.department_id) {
      this.prefilled_department = true;
      this.form.department_id = this.departments.find(
        (x) => x.id == this.department_id
      )?.id;
    }
    if (this.degree_id) {
      this.prefilled_degree = true;
      this.form.degree_id = this.degrees.find(
        (x) => x.id == this.degree_id
      )?.id;
    }
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.program };
        this.exisiting_qualifications = (this.form.qualifications || []).map(
          (p) => p.id
        );
        this.form.qualifications = this.form.qualifications.map((p) => p.id);
      }

      await Promise.all([this.getQualifications()]);
    },
    async getDegrees() {
      await this.$axios
        .get("degrees")
        .then((res) => {
          this.degrees = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getQualifications() {
      await this.$axios
        .get("qualifications")
        .then((res) => {
          this.qualifications = res.data.data;
          this.qualifiications = this.qualifications.sort(
            (a, b) => a.level - b.level
          );
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getDepartments() {
      await this.$axios
        .get("departments")
        .then((res) => {
          this.departments = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },

    getIds(arr) {
      return arr.map((item) => item.id);
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        const oldIds = this.exisiting_qualifications || [];
        const newIds = this.form.qualifications;
        this.form.delete_qualifications = oldIds.filter(
          (id) => !newIds.includes(id)
        );
        this.form.create_qualifications = newIds.filter(
          (id) => !oldIds.includes(id)
        );

        this.$emit("update", this.form);
      } else {
        this.form.create_qualifications = this.form.qualifications;
        this.$emit("create", this.form);
      }
    },
    updateQualificationSelection(selectedIds) {
      if (!selectedIds.length) return;
      const maxLevel = Math.max(
        ...selectedIds.map((id) => {
          const qualification = this.qualifications.find((q) => q.id === id);
          return qualification ? qualification.level : 0;
        })
      );

      this.form.qualifications = this.qualifications
        .filter((q) => q.level <= maxLevel)
        .map((q) => q.id);
    },
  },
};
</script>

<style scoped>
.form-label {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
